import api from '../../../utils/andromeda-api';

export const postPreferencePageAPI = (body, cancelToken) => {
  return api.post('/preference/send-preference', body, {
    cancelToken,
  });
};
